import React from 'react'

class BoxCell extends React.Component {

  cellstyle = () => {
    const style = { backgroundColor: 'transparent' }

    const { bgcolor, border, center } = this.props

    if (bgcolor) style.backgroundColor = bgcolor
    if (border) {
      style.borderRightWidth = 1
      style.borderRightStyle = 'solid'
    }
    if (center) style.textAlign = 'center'
    return style
  }

  render() {
    const { icon } = this.props
    return (
      <div className='box-cell' style={this.cellstyle()}>
        { icon ? (<span className='box-bg-icon middle right'>{icon}</span>) : null }
        { this.props.children }
      </div>
    )
  }
}

export default BoxCell



// WEBPACK FOOTER //
// ./src/components/widgets/BoxCell.js